import Content from "@/sections/Content";
import ProductCards from "@/sections/ProductCards";
import type { ProductCardItem } from "@/sections/ProductCards";
import { Header, ReviewsFooter } from "@commerce-core/react-components";

interface LayoutProps {
  root: {
    header?: {
      navigation_links?: string[];
      link_color?: string;
    };
    page_settings?: string;
    product_cards?: {
      tr_heading?: string;
      tr_subheading?: string;
      products?: ProductCardItem[];
    };
    footer?: {
      footer_columns?: {
        tr_title?: string;
        link?: {
          url: string;
          tr_label: string;
          targetBlank: boolean;
          link_type: string;
          page: string;
        }[];
      }[];
    };
  };
}

export default function Layout({ root }: LayoutProps) {
  return (
    <>
      <Header
        navLinks={root?.header?.navigation_links}
        settings={root?.page_settings}
        generalSettings={window.general_settings}
        classes={{
          header: "max-w-[972px] lg:h-[80px] p-3 justify-center",
          navLinksDesktop: "w-full justify-end !text-lg !font-normal",
          logo: "max-w-[300px] h-auto",
        }}
      />
      <Content />
      <ProductCards section={root?.product_cards} />
      <ReviewsFooter
        footer={root?.footer}
        generalSettings={window.general_settings}
        classes={{
          wrapper: "!w-full !max-w-none border-t border-gray-200 !pt-10",
          grid: "max-w-[972px] mx-auto",
          brandName: "max-w-[972px] mx-auto",
        }}
      />
    </>
  );
}
